"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fineStructureDependencies = void 0;

var _dependenciesBigNumberClassGenerated = require("./dependenciesBigNumberClass.generated.js");

var _factoriesAny = require("../../factoriesAny.js");

/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
var fineStructureDependencies = {
  BigNumberDependencies: _dependenciesBigNumberClassGenerated.BigNumberDependencies,
  createFineStructure: _factoriesAny.createFineStructure
};
exports.fineStructureDependencies = fineStructureDependencies;